/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Read_Message_History_HintInputs */



/**
* | output |
* | --- |
* | "Allows members to read previous messages sent in channels. If this permission is disabled, members only see messages sent when they are online. This does not..." |
*
* @param {Leveling_Perm_Read_Message_History_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_read_message_history_hint = /** @type {((inputs?: Leveling_Perm_Read_Message_History_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Read_Message_History_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет участникам читать сообщения, отправленные в каналы раньше. Если право отключено, участники видят только сообщения, отправленные, пока они в сети. На ветки и публикации форумов это действует не полностью.")
	return /** @type {LocalizedString} */ ("Allows members to read previous messages sent in channels. If this permission is disabled, members only see messages sent when they are online. This does not fully apply to threads and forum posts.")
});